<template lang="pug">
BlueSearch
  template(#results="{}")
    .app-utility
      .page-heading
        h1.title.center Search Results
    SearchResults
</template>

<script>
export default {
  name: "NctcogSearchApp",
};
</script>

<style lang="scss" scoped>
#bluesearch::v-deep {
  font-family: $fontFamilyBase;
  .search{
    &__layout{
      padding:0 2rem;
    }
    &__header{
      position: relative;
      overflow:unset;
      padding: 1.75rem 0;
      &::before{
        background-color: var(--searchColor, $navy); 
        position: absolute;
        content: '';
        height: calc(100% + 1rem);
        width:150vw;
        left: -50vw;
        top:-1rem;
      }
    }
    &__results{
      .search-result{
        &__date{
          display: none;
        }
      }
    }
    &-query__input{
      padding: 15px;
      background-color: $white;
      width: 100%;
    }
    &-query__wrapper{
      border-color: #c6c6c6;
      border-radius: 4px;
      border-style: solid;
      border-width: 3px;
      overflow: hidden;
      &::after{
        height: auto !important;
        visibility: visible !important;
        content: '' !important;
        font-family: 'icomoon' !important;
        position: absolute !important;
        top: 41% !important;
        right: 30px !important;
        color: $navy !important;
        font-size: 1.3em !important;
        margin: -10px -10px 0 0 !important;
      }
    }
    &-query__form{
      position: relative;
    }
    &-query__submit{
      position: absolute;
      right:0;
      display: inline-block;
      margin: 0;
      padding: 12px 30px;
      font-size: .875em;
      font-weight: normal;
      color: $navy;
      font-weight: bold;
      background: transparent;
      border: 0;
      font-size: .1px;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      overflow: visible;
      border-radius: 5px;
      transition: all .1s linear;
      height: 100%;
    }
    &-pagination__number:is(span){
      background-color: $navy;
    }
    &-pagination__next, &-pagination__prev{
      &:is(button){
        &:hover{
          background-color: $navy;
        }
      }
    }
  }
  a{
    color:$navy;
    font-size: 1.25rem;
    font-family: $fontFamilyBase;
  }
  .loader{
    div:after {
      background: $navy;
    }
  }
}
</style>